export const getCloseLeadUrl = (closeLeadId?: string | null) =>
  closeLeadId ? `https://app.close.com/lead/${closeLeadId}` : ''
